export default "__VITE_ASSET__BCWlSnQW__"